import { Clipboard, BellOff, Trash2, Settings, AlertOctagon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const EmailToolbar = () => {
  const { t } = useTranslation();

  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            {t('landing.emailToolbar.title')}
          </h2>
          <p className="text-lg text-gray-700 max-w-2xl mx-auto">
            {t('landing.emailToolbar.subtitle')}
          </p>
        </div>
        
        <div className="max-w-4xl mx-auto">
          <div className="bg-white shadow-xl rounded-xl overflow-hidden">
            {/* Email header */}
            <div className="bg-gray-100 p-4 flex items-center justify-between border-b border-gray-200">
              <div className="flex items-center">
                <div className="h-10 w-10 rounded-full bg-blue-100 flex items-center justify-center text-blue-600 font-bold">A</div>
                <div className="ml-3">
                  <div className="text-sm font-medium text-gray-900">Amazon.com</div>
                  <div className="text-xs text-gray-500">order-confirm@amazon.com</div>
                </div>
              </div>
              <div className="text-xs text-gray-500">12:34 PM</div>
            </div>
            
            {/* Uumail Toolbar */}
            <div className="bg-gray-100 px-4 py-3 border-b border-gray-200">
              <div className="flex flex-wrap items-center justify-between gap-2">
                <div className="text-sm text-gray-700">
                  {t('landing.emailToolbar.sentTo')}: <span className="font-medium text-blue-600">jeff.amazon@uumail.io</span>
                </div>
                <div className="flex flex-wrap gap-2">
                  <button className="inline-flex items-center px-3 py-1 bg-gray-200 hover:bg-gray-300 rounded text-xs font-medium text-gray-700 transition-colors">
                    <Clipboard className="h-3 w-3 mr-1" /> {t('landing.emailToolbar.actions.viewLogs')}
                  </button>
                  <button className="inline-flex items-center px-3 py-1 bg-gray-200 hover:bg-gray-300 rounded text-xs font-medium text-gray-700 transition-colors">
                    <BellOff className="h-3 w-3 mr-1" /> {t('landing.emailToolbar.actions.muteAlias')}
                  </button>
                  <button className="inline-flex items-center px-3 py-1 bg-gray-200 hover:bg-gray-300 rounded text-xs font-medium text-gray-700 transition-colors">
                    <Trash2 className="h-3 w-3 mr-1" /> {t('landing.emailToolbar.actions.deleteAlias')}
                  </button>
                  <button className="inline-flex items-center px-3 py-1 bg-gray-200 hover:bg-gray-300 rounded text-xs font-medium text-gray-700 transition-colors">
                    <Settings className="h-3 w-3 mr-1" /> {t('landing.emailToolbar.actions.createRule')}
                  </button>
                  <button className="inline-flex items-center px-3 py-1 bg-gray-200 hover:bg-gray-300 rounded text-xs font-medium text-gray-700 transition-colors">
                    <AlertOctagon className="h-3 w-3 mr-1" /> {t('landing.emailToolbar.actions.markSpam')}
                  </button>
                </div>
              </div>
            </div>
            
            {/* Email content mock */}
            <div className="p-6">
              <h3 className="text-xl font-medium text-gray-900 mb-4">{t('landing.emailToolbar.demoEmail.title')}</h3>
              <p className="text-gray-700 mb-4">
                {t('landing.emailToolbar.demoEmail.content')}
              </p>
              <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
                <div className="font-medium text-gray-900 mb-2">{t('landing.emailToolbar.demoEmail.orderDetails.title')}:</div>
                <div className="text-gray-700 text-sm">
                  {t('landing.emailToolbar.demoEmail.orderDetails.orderNumber')}: 123-4567890-1234567<br />
                  {t('landing.emailToolbar.demoEmail.orderDetails.delivery')}: June 15, 2025
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EmailToolbar;